<script setup lang="ts">
const props = defineProps({
  isFiltersActive: {
    type: Boolean,
    default: false,
  },
  isSearchActive: {
    type: Boolean,
    default: false,
  },
  isHiddenFilters: {
    type: Boolean,
    default: false,
  },
  // Mostrar/ocultar botões individualmente (mantém padrão atual)
  showReload: {
    type: Boolean,
    default: true,
  },
  showFilter: {
    type: Boolean,
    default: true,
  },
  showSearch: {
    type: Boolean,
    default: true,
  },
  // Botão customizado para mobile (apenas ícone)
  showCustomMobile: {
    type: Boolean,
    default: false,
  },
  reloadingPage: {
    type: Boolean,
    required: true,
  },
  // Rota customizada para o botão voltar (se não definida, usa router.back())
  backRoute: {
    type: String,
    default: '',
  },
});

type Emits = {
  'update:isFiltersActive': any;
  'update:isSearchActive': any;
  'reload-page': [];
  'custom-mobile-action': [];
};

const emit = defineEmits<Emits>();

const isFiltersActiveHeader = computed({
  get() {
    return props.isFiltersActive;
  },
  set(value) {
    emit('update:isFiltersActive', value);
  },
});

const isSearchActiveHeader = computed({
  get() {
    return props.isSearchActive;
  },
  set(value) {
    emit('update:isSearchActive', value);
  },
});

function activeFilters() {
  isFiltersActiveHeader.value = !isFiltersActiveHeader.value;
}

function activeSearch() {
  isSearchActiveHeader.value = !isSearchActiveHeader.value;
}

const router = useRouter();

function handleBackClick() {
  if (props.backRoute && props.backRoute !== '') {
    router.push(props.backRoute);
  } else {
    router.back();
  }
}
</script>

<template>
  <header :class="$style.SmarticoHeader">
    <div :class="$style.header">
      <button
        :class="$style.backButton"
        @click="handleBackClick"
      >
        <NuxtIcon name="arrows/arrow_left" />
      </button>

      <p :class="$style.title">
        <slot></slot>
      </p>

      <div
        v-if="!isHiddenFilters"
        :class="$style.searchWrapper"
      >
        <button
          v-if="showReload"
          @click="emit('reload-page')"
        >
          <NuxtIcon
            :class="{ [$style.animate]: reloadingPage }"
            name="sync"
          />
        </button>

        <!-- Slot para ícone customizado no mobile -->
        <slot
          v-if="showCustomMobile"
          name="custom-mobile-button"
        ></slot>

        <button
          v-if="showFilter"
          @click="activeFilters()"
        >
          <NuxtIcon
            v-if="!isFiltersActiveHeader"
            name="filter"
          />
          <NuxtIcon
            v-else
            name="times_circle"
          />
        </button>

        <button
          v-if="showSearch"
          @click="activeSearch()"
        >
          <NuxtIcon
            v-if="!isSearchActiveHeader"
            name="search"
          />
          <NuxtIcon
            v-else
            name="times_circle"
          />
        </button>
      </div>
    </div>

    <slot name="filters"></slot>
  </header>
</template>

<style module lang="postcss">
.SmarticoHeader {
  @apply mt-1 sm:mb-2 md:mt-1 md:mb-2 lg:flex items-center lg:justify-between xl:mt-4 xl:mb-2 xl:pb-1;

  .header {
    @apply flex justify-start items-center text-left md:mb-3 lg:mb-0 lg:pr-2;
  }

  .backButton {
    @apply flex items-center bg-transparent text-texts/60;

    svg {
      @apply flex-none;
    }
  }

  .title {
    @apply inline ml-3 text-[.95rem] text-texts font-bold;
  }

  .searchWrapper {
    @apply flex md:hidden ml-auto;

    button {
      @apply py-2.5 px-2 first:ml-3 last:mr-1;
    }

    svg {
      @apply w-4 h-4 text-texts/60;
    }
  }
}

.animate {
  animation: rotate 600ms infinite linear;
}

@keyframes rotate {
  to {
    transform: rotate(1turn);
  }
}
</style>
